import { Vue } from 'vue-property-decorator';
import routeService from './route.service';

import { IConnectModel, IUserModel } from '@/models/account.model';
import accountService from './account.service';

export default {
  updateUser(context: Vue, checkUrl: boolean, redirect: boolean, idUser?: number, tokenValue?: string, redirectUrl?: string, redirectToAccount: boolean = false): void {
    const user = idUser != null ? idUser : context.$store.getters.user.Id;
    const token = tokenValue != null ? tokenValue : context.$store.getters.token.Value;
    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "profile/user/" + user + "?include=Block";

    accountService.get<IUserModel>(context, url, { headers: { Authorization: "Bearer " + token } })
      .then(async response => {
        response = this.handleUser(response);

        const _url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "profile/connects";

        accountService.get<Array<IConnectModel>>(context, _url, { headers: { Authorization: "Bearer " + token } })
          .then(async (response) => {
            await context.$store.dispatch("updateConnect", response);
          });
        await context.$store.dispatch("updateUser", response);

        if (redirect && redirectUrl != null && redirectUrl != '') {
          let url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "redirect/allowed-redirect-domains";

          accountService.get<Array<string>>(context, url)
            .then(response => {
              for (let domain of response) {
                if (redirectUrl.match(domain) != null
                  && (redirectUrl.startsWith("https://") || redirectUrl.startsWith("http://"))
                ) {
                  window.location.href = redirectUrl;

                  return;
                }
              }

              context.$store.dispatch("updateIsLoading", false);
            });
        } else {
          context.$store.dispatch("updateIsLoading", false);
          routeService.redirectToAccount(context, checkUrl, redirectToAccount);
        }
      })
      .catch(error => {
        context.$store.dispatch("updateIsLoading", false);
      });
  },

  handleUser(user: IUserModel): IUserModel {
    if (user) {
      user.Titles = user.Titles || '';
      user.Titles = user.Titles.toString();
      if (user.Titles && user.Titles.length) {
        const titles = user.Titles.split(';');
        user.TitleName = titles.join(' ');
      }
    }

    return user;
  }

}
